import { OptionType } from "@atlaskit/select";
import { FC, useMemo, useState } from "react";
import { HOCType } from "../../constants/types";
import { createContext } from "../../helpers/createContext";

import { ALL_UNIT_OPTION } from "./PlacementWorksheetTableFilterSelect";

interface IPlacementWorksheetTableContext {
  isShowAll: boolean;
  search?: string;
  filterUnit: OptionType;
  setFilterUnit: React.Dispatch<React.SetStateAction<OptionType>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setIsShowAll: React.Dispatch<React.SetStateAction<boolean>>;
}

const [
  PlacementWorksheetTableContext,
  usePlacementWorksheetTableContext,
] = createContext<IPlacementWorksheetTableContext>();

const PlacementWorksheetTableProvider: FC = (props) => {
  const [isShowAll, setIsShowAll] = useState(false);
  const [search, setSearch] = useState("");
  const [filterUnit, setFilterUnit] = useState<OptionType>(ALL_UNIT_OPTION);

  const value = useMemo(
    () => ({
      isShowAll,
      search,
      filterUnit,
      setFilterUnit,
      setSearch,
      setIsShowAll,
    }),
    [isShowAll, search, filterUnit]
  );

  return (
    <PlacementWorksheetTableContext.Provider value={value}>{props.children}</PlacementWorksheetTableContext.Provider>
  );
};

const withPlacementWorksheetTableProvider: HOCType = (WrappedComponent) => (props) => (
  <PlacementWorksheetTableProvider>
    <WrappedComponent {...props} />
  </PlacementWorksheetTableProvider>
);

export {
  PlacementWorksheetTableContext,
  usePlacementWorksheetTableContext,
  PlacementWorksheetTableProvider,
  withPlacementWorksheetTableProvider,
};
